import * as React from 'react';
import * as styles from '../support.module.scss';
import TableColumn from './table-column';
import SortingOptions from '../../../models/enums/sortingOptions';
import { SupportContext } from '../../../shared/support-context';
import useSupport from '../../../hooks/useSupport';
import Scrollbars from 'react-custom-scrollbars';
import SupportEntry from './support-entry';
import ViewTicketModal from '../viewTicketModal/view-ticket-modal';
import SupportTicket from '../../../models/supportTicket';
import Table from '../../table/table';
import TableHead from '../../table/table-head';
import TableBody from '../../table/table-body';

const SupportTable = ({ loading }) => {
  const { tickets } = React.useContext(SupportContext);
  const { fetchSupportTickets } = useSupport();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [activeTicket, setActiveTicket] = React.useState<SupportTicket>(null);

  const handleModal = (isOpen: boolean, ticket: SupportTicket) => {
    setIsModalOpen(isOpen);
    setActiveTicket(ticket);
  };

  return (
    <div className={styles.tableWrapper}>
      <ViewTicketModal ticket={activeTicket} isOpen={isModalOpen} onClose={handleModal} />
      <Scrollbars className={styles.scrollTable} autoHide={true} universal={true}>
        <Table loading={loading} results={tickets}>
          <TableHead>
            <th>Type</th>
            <th>
              <TableColumn title="Ref" orderType={SortingOptions.Key} fetchSupportTickets={fetchSupportTickets} />
            </th>
            <th>
              <TableColumn
                title="Summary"
                orderType={SortingOptions.Summary}
                fetchSupportTickets={fetchSupportTickets}
              />
            </th>
            <th>
              <TableColumn title="Status" orderType={SortingOptions.Status} fetchSupportTickets={fetchSupportTickets} />
            </th>
            <th>
              <TableColumn
                title="Requester"
                orderType={SortingOptions.Reporter}
                fetchSupportTickets={fetchSupportTickets}
              />
            </th>
            <th>Org.</th>
            <th>
              <TableColumn
                title="Created"
                orderType={SortingOptions.Created}
                fetchSupportTickets={fetchSupportTickets}
              />
            </th>
            <th>
              <TableColumn
                title="Updated"
                orderType={SortingOptions.Updated}
                fetchSupportTickets={fetchSupportTickets}
              />
            </th>
          </TableHead>
          <TableBody>
            {!tickets || tickets.length === 0 ? (
              <tr>
                <td className={styles.noResults}>There are currently no support requests</td>
              </tr>
            ) : (
              tickets.map((ticket, index) => {
                return <SupportEntry key={ticket.issueName} ticket={ticket} handleModal={handleModal} />;
              })
            )}
          </TableBody>
        </Table>
      </Scrollbars>
    </div>
  );
};

export default SupportTable;
